import { FC } from "react";

import { LineChart } from "../../../Charts/LineChart/LineChart";
import { UiColors } from "../../../../config/ui/colors";

export interface TradeShareDataPoint {
	time: number;
	value: number;
}

interface TradeShareLineChartProps {
	data: TradeShareDataPoint[];
	yAxisLabel?: string;
	chartSubtitle?: string;
	color?: string;
}

const X_TICKS = [2014, 2016, 2018, 2020, 2022, 2024];
const Y_TICKS = [55, 60, 65, 70, 75, 80];

const TradeShareLineChart: FC<TradeShareLineChartProps> = ({ data, yAxisLabel, chartSubtitle, color = UiColors.charts.primary }) => (
	<LineChart
		YAxisLabel={yAxisLabel}
		data={data}
		height={350}
		dataKeys={[{ color, name: "value", showLabel: true }]}
		XAxisProps={{
			dataKey: "time",
			padding: { left: 30, right: 30 },
		}}
		xDomain={[2014, 2024]}
		customXTicks={X_TICKS}
		YAxisProps={{
			domain: [55, 80],
			ticks: Y_TICKS,
			tickFormatter: (v: number) => `${v}%`,
			interval: 0,
		}}
		showToolTip={false}
		chartSubtitle={chartSubtitle}
	/>
);

export { TradeShareLineChart };
